/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon'; // Outline

const MapPinOutline = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("g", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 12.75c1.66 0 3-1.34 3-3 0-1.65-1.34-3-3-3s-3 1.35-3 3c0 1.66 1.34 3 3 3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.5 9.75c0 6.75-7.5 12-7.5 12s-7.5-5.25-7.5-12c0-1.99.79-3.89 2.2-5.3 1.4-1.41 3.31-2.2 5.3-2.2s3.9.79 5.3 2.2a7.485 7.485 0 0 1 2.2 5.3z"
}))); // Fill


const MapPinFill = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12 1.5c-2.19 0-4.28.87-5.83 2.42S3.75 7.56 3.75 9.75c0 7.06 7.5 12.4 7.82 12.62.13.09.28.13.43.13s.3-.04.43-.13c.32-.22 7.82-5.56 7.82-12.62 0-2.19-.87-4.28-2.42-5.83S14.19 1.5 12 1.5zm0 5.25c.59 0 1.17.18 1.67.51.49.33.87.8 1.1 1.34.23.55.29 1.16.17 1.74-.11.58-.4 1.11-.82 1.53s-.95.71-1.53.82c-.59.12-1.19.06-1.74-.17-.55-.22-1.01-.61-1.34-1.1a2.988 2.988 0 0 1 .37-3.79c.56-.56 1.32-.88 2.12-.88z"
})); // DuoTone


const MapPinDuotone = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12 2.25c-1.99 0-3.9.79-5.3 2.2a7.485 7.485 0 0 0-2.2 5.3c0 6.75 7.5 12 7.5 12s7.5-5.25 7.5-12c0-1.99-.79-3.89-2.2-5.3a7.468 7.468 0 0 0-5.3-2.2zm0 10.5c-.59 0-1.17-.17-1.67-.5-.49-.33-.87-.8-1.1-1.35s-.29-1.15-.17-1.73c.11-.59.4-1.12.82-1.54s.95-.7 1.53-.82c.59-.12 1.19-.06 1.74.17s1.01.61 1.34 1.11a2.98 2.98 0 0 1-.37 3.78c-.56.57-1.32.88-2.12.88z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("g", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 12.75c1.66 0 3-1.34 3-3 0-1.65-1.34-3-3-3s-3 1.35-3 3c0 1.66 1.34 3 3 3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.5 9.75c0 6.75-7.5 12-7.5 12s-7.5-5.25-7.5-12c0-1.99.79-3.89 2.2-5.3 1.4-1.41 3.31-2.2 5.3-2.2s3.9.79 5.3 2.2a7.485 7.485 0 0 1 2.2 5.3z"
})));
/**
  Icon MapPinIcon in maps group
*/


export const MapPinIcon = createIcon('MapPinIcon', 'map-pin', 'maps', MapPinOutline, MapPinFill, MapPinDuotone, "0 0 24 24");